export default __webpack_public_path__ + "static/media/iconaskbtn.a2530702.svg";